<template>
  <div class="input">
    <div class="input-label">クイズセット</div>

    <div v-if="quizsets.length === 0">
      クイズセットがありません。
    </div>
    <div v-else class="input-group">
      <input-select
        :option="quizset"
        :options="quizsets"
        name="name"
        @select="(o) => quizset = o" />
    </div>
  </div>
</template>

<script>
import InputSelect from '@/components/Input/Select'

export default {
  components: {
    InputSelect
  },

  created: async function () {
    await this.$store.dispatch('eventQuizset/availableQuizsets')
  },

  computed: {
    quizsets: function () {
      return this.$store.state.eventQuizset.quizsets
    },

    quizset: {
      get: function () {
        return this.$store.state.eventQuizset.quizset
      },
      set: function (quizset) {
        this.$store.commit(
          'eventQuizset/setQuizset',
          quizset
        )
      }
    },

    title: function () {
      if (this.localQuizet) {
        return this.localQuizet.get('name')
      }
      return ''
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/styles/_form.scss';
</style>
